import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/privacy.scss";

function FAQs() {
  const items = [
    ["How can I contact shiskerstone?", "Email print@shiskerstone.xyz with your order number when applicable. We aim to reply within two business days."],
    ["When will my order ship?", "In-stock pieces usually leave our studio within 1–3 business days. Made-to-order lead times are shown on the product page or order confirmation."],
    ["Can I change or cancel an order?", "Contact us as soon as possible. We cannot guarantee changes after an order enters packing or production."],
    ["Do you ship internationally?", "Available destinations and shipping options appear at checkout. The recipient is responsible for any import duties and local taxes unless checkout states otherwise."],
    ["How should I care for my jewelry?", "Store pieces separately in a dry place, avoid chemicals and perfume, and wipe metal and stones gently with a soft, dry cloth after wear."],
    ["Are natural stones identical?", "No. Color, pattern, shape, and surface character can vary naturally, making each finished piece subtly individual."],
    ["What is your return policy?", "Eligible unworn items may be requested for return within 14 days of delivery. See the Returns page for conditions and exclusions."],
  ];

  return (
    <div className="privacy">
      <Header />
      <main>
        <div className="inner-pg">
          <div className="content">
            <h1>Frequently Asked Questions</h1>
            {items.map(([question, answer]) => (
              <section key={question}>
                <strong>{question}</strong>
                <p>{answer}</p>
                <br />
              </section>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default FAQs;
